import React, { PropsWithChildren } from "react";

import { SpacingProps } from "@brexhq/shared/types/SpacingScale";

import { StyledTopSpacing } from "./TopSpacing.elements";

/**
 * Add spacing above components.
 * Currently used for Jobs module.
 */

export const TopSpacing: React.FC<PropsWithChildren<SpacingProps>> = ({
  topSpacing,
  children,
  anchor,
}) => {
  if (topSpacing === "none" || !topSpacing) return <>{children}</>;

  return (
    <StyledTopSpacing id={anchor} margin={topSpacing}>
      {children}
    </StyledTopSpacing>
  );
};
